<template>
  <div class="paynewBox" id="paydongPop">
    <div class="payBoxCon">
      <div class="payHeader">
        <div class="payLeftBox">
          <div class="payUIc">
            <img class="payUIcImg" :src="userInfo.avatarurl" alt="" v-show="userInfo.avatarurl">
            <img class="payUIcImg" src="./images/payImg/userAva.png" alt="" v-show="!userInfo.avatarurl">
          </div>

          <div class="payUDet">
            <div class="payUName">
              <div class="payname">
                {{ userInfo.nickname }}
              </div>
              <div class="paySty">个人</div>
            </div>
            <div class="payUInfo">
              <div class="infoItem">
                <div class="iIname">会员ID ：</div>
                <div class="iIData">{{ userInfo.uid }}
                </div>
              </div>
              <div class="infoItem">
                <div class="iIname">当前身份 ：</div>
                <div class="iIData iIDataOth">{{ userInfo.vip_name }}</div>
              </div>
              <div class="infoItem">
                <div class="iIname">到期时间 ：</div>
                <div class="iIData iIDataOth">{{ userInfo.vip_end_date }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="payRightBox">
          <div class="payRibox">
            <div class="closePayBtn" @click="closePayPop">
              <img class="payCloseIm" src="./images/payImg/close.png" alt="">
            </div>
            <div class="payMenu">
              <div class="payMitem" @click="tokefu">人工客服</div>
              <div class="payMitem" @click="toInvoice">开发票</div>
            </div>
          </div>
        </div>
      </div>
      <div class="payContent payMainSty">
        <div class="isVipMask" v-show="userInfo.vip_type == 5 && !isCompany">
          <div class="isEveTips" @click="changePayTye(1)">您已经是永久会员，无需重复购买，<span style="color: red;">点击购买积分包</span>
          </div>
        </div>
        <div class="isVipMask" v-show="!userInfo.vip_type && isCompany">
          <div class="isEveTips" @click="changePayTye(0)">字数包是会员专享服务，您还不是会员，<span style="color: red;">点此去开通</span>
          </div>
        </div>
        <div class="paySelect">
          <div :class="isCompany == 0 ? 'payItem payItemAct' : 'payItem'" @click="changePayTye(0)">
            开通超级会员
            <div class="payItemAcI" v-show="isCompany == 0"></div>
          </div>
          <div
            :class="isCompany == 1 ? 'payItem payItemother payItemAct' : 'payItem payItemother'" @click="changePayTye(1)">
            购买积分包 <div class="jifenList">
              <div class="jifenItem">会员专享</div>
              <div class="jifenItem">超值</div>
            </div>
            <div class="payItemAcI" v-show="isCompany == 1"></div>
            <img class="payHot" src="./images/payImg/hot.png" alt="">
          </div>
        </div>
        <!-- <div style="color: #000;" @click="paySuccessFn">模拟成功</div> -->
        <div class="payList">
          <div :class="vipType == item.vip_type ? 'payTypeItem payTypeItemAct' : 'payTypeItem'"
            v-for="(item, index) in payList" @click="selectPay(item)" :key="item.vip_id">
            <div class="payTyTit">{{ item.name }}</div>
            <div class="payTynum">
              <div class="payRMB">¥</div>
              <div class="payNumber">{{ item.pay_money }}</div>
            </div>
            <div class="payTyTips">
              {{ item.tip2 }}
            </div>
            <!-- <div class="payTyTips">
                {{ item.tip3 }}
            </div> -->
            <div class="payTyTips">
              {{ item.privilege[0] }}
            </div>
            <div class="payTyTips" @mouseenter="curQuyShow = item.vip_type" @mouseleave="curQuyShow = null">
              <div class="payTqyTip">其他全部{{ item.privilege.length-1 }}项会员权益</div>
              <img src="./images/payImg/tipsIcon.png" class="payTqyTipImg" />
            </div>
            <div :class="vipType == item.vip_type ? 'payQuyiLsit payQuyiLsitOther' : 'payQuyiLsit'"
              v-show="curQuyShow == item.vip_type">
              <div class="payqyItem" v-for="qy in item.privilege.slice(1, 5)">{{ qy }}</div>
            </div>


            <div class="favorite" v-if="item.tip1&&index==3">{{ isCompany?'超值特惠':item.tip1 }}</div>
            <img v-show="vipType == item.vip_type" src="./images/payImg/img_icon_45.png" class="payYes" />
            <div class="evePayTimer" v-if="index == 3 & isCompany == 0">
              永久会员将于 {{ formattedTime }} 后下架
            </div>
          </div>
        </div>
        <div class="top_bor"></div>


        <div class="payDataDetail">

          <div class="payCode">
            <div class="jiao"></div>
            <!-- v-if="timerout" -->
            <div class="time_out_cover" v-if="false" @click="getPayInfo"> 二维码已过期，点击刷新</div>
            <div class="time_out_cover" v-if="!isAgree"> 请同意并阅读协议</div>

            <!-- <img class="payCodImg" :src="code_url" alt=""> -->
            <canvas class="payCodImg" id="canvas"></canvas>
            <!-- <div class="paySuccess" @click="paySuccessFn">模拟成功</div> -->
          </div>
          <div class="paydetailList">
            <div class="payMoney">应付金额 ：
              <span class="payIC">¥</span> <span class="payMone">{{ payMoney }}</span> 元

              <!--              <div class="payTipsBox" v-show="isCompany==0">-->
              <div class="" v-show="!couponShow && !isCompany" :class="['payTipsBox', payMoney < 100 ? 'pos_l168' : 'pos_l179']">
                <div class="one_right">
                  <div class="right_bgc">
                    <div>
                    </div>
                    历史最低价
                  </div>
                </div>
                <div class="one_right invoice">
                  <div class="right_bgc">
                    可开发票
                  </div>
                </div>
                <div :class="['one_right', isCompany == 1 ? 'one_oth_le3' : payMoney < 100 ? 'one_oth_le' : 'one_oth_le2']">
                  <div class="one_right_money">{{ '已优惠' + zongPay + '元' }}</div>
                  <div class="right_bgc">
                    <div></div>
                    放弃本次优惠，下次将原价购买
                  </div>
                </div>
              </div>
            </div>
            <div class="new_line_pay">
                <div class="zhixiangbox">
                  <img src="./images/payImg/zhizzImg.png" class="zhiRowImg" alt="">
                  <div class="tuijainzhizfb">推荐支付宝支付，随机立减1-3元</div>
                </div>
              <div @click="newpayHow=2" :class="newpayHow==2?'lin_pay_item lin_pay_item_bao lin_payact_bao':'lin_pay_item lin_pay_item_bao'">
                  <img class="pay_icon" src="./images/payImg/img_icon_48.png" alt="">支付宝支付
                  <img src="../views/img/duihao.png" class="selIcimg" v-show="newpayHow==2" alt="">
              </div>
              <div @click="newpayHow=1" :class="newpayHow==1?'lin_pay_item lin_pay_item_wei lin_payact_wei':'lin_pay_item lin_pay_item_wei'">
                  <img class="pay_icon" src="./images/payImg/weixinpay.png" alt="">微信支付
                  <img src="../views/img/weixinduihao.png" class="selIcimg" v-show="newpayHow==1" alt="">

              </div>
            </div>
            <!-- <div class="line_cen">
              请使用
              <div class="pay_type wx_pay"><img class="pay_icon" src="./images/payImg/weixinpay.png" alt="">微信支付</div>或
              <div class="pay_type ali_pay"><img class="pay_icon" src="./images/payImg/img_icon_48.png" alt="">支付宝
                <div class="zhixiangbox">
                  <img src="./images/payImg/zhizzImg.png" class="zhiRowImg" alt="">
                  <div class="tuijainzhizfb">推荐支付宝支付，随机立减1-3元</div>
                </div>
              </div>扫码支付

            </div> -->
            <div class="argumentPay">
                            <div class="argCheBox" v-show="!isAgree" @click="checkAgree(1)"></div>
              <img @click="checkAgree(0)" v-show="isAgree" src="./img/icon_img_05.png" class="argCheYes" alt="">
              同意并阅读<span @click="toXieyi">《用户隐私条款》</span>
            </div>
            <div class="payYouhui" v-show="isYouhuiShow && isCompany == 0">
              <div class="youhuiLeft">
                <div class="youhuiMoney">
                  <div class="youRmb">¥</div>
                  <div class="youMNum">50</div>
                </div>
                <div class="youhuiTip">永久会员专享</div>
              </div>
              <div class="youhuiRig">
                <div class="youT">新用户限时升级永久会员</div>
                <div class="youTimBox">
                  <div class="timBItem">{{ `${Math.floor(remainingTime / 60).toString().padStart(2, '0')}` }}</div>
                  :
                  <div class="timBItem">{{ `${(remainingTime % 60).toString().padStart(2, '0')}` }}</div>
                  :
                  <div class="timBItem">{{ peakerNum1 }}</div>
                  优惠失效
                </div>
              </div>
              <div class="youSelIc">
                <img class="yesImg" src="./images/payImg/yesIc.png" alt="">
              </div>
              <div class="mskPorin"></div>
              <div class="mskLine"></div>
              <div class="mskPorinOth"></div>
              <div class="youhuiLeft2" v-show="isYouhuiShow2">
                <div class="mskPorin mskPorin1"></div>
                <div class="mskPorinOth mskPorin2"></div>
                <div class="mskLine mskLine1"></div>
                <div class="youhuiLeft">
                  <div class="youhuiMoney">
                    <div class="youRmb">¥</div>
                    <div class="youMNum">100</div>
                  </div>
                  <div class="youhuiTip youhuiTip1">永久会员专享</div>
                </div>
                <div class="youSelIc">
                  <img class="yesImg" src="./images/payImg/yesIc.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="payFoot payMainSty">
        <div class="pfLbox">
          会员权益 ：付费后，解锁对应会员级别所有功能
        </div>
        <div class="pfRbox">
          <!-- <div class="pfletter"></div> -->
          <img class="pfletter" src="./images/payImg/pfletter.png" alt="">
          <div class="lettTit">感谢信 ：</div>
          <el-carousel height="20px" direction="vertical" indicator-position='none' autoplay>
            <el-carousel-item v-for="item in ganxieList" :key="item.id">
              <div class="lettDetail">感谢用户ID {{ item.user_id }}在 <span class="payTime lrScro">{{ item.datetime
                  }}</span>成功升级为<span class="payTime lScro">{{ item.vip_type }}</span></div>
            </el-carousel-item>
          </el-carousel>
          <!-- <div class="lettDetail">感谢用户ID764587在 <span class="payTime lrScro">{{ utils.getFormattedTime(4) }}</span> 成功升级为 <span class="payTime lScro">永久会员</span></div> -->
        </div>
      </div>
      <!-- 9元优惠 -->
      <div class="payClosePop" id="youyipop" v-show="fisYouh">
        <div class="payFirBox">
          <img src="./images/payImg/yhFIr.png" alt="">

          <div class="payYouDetBox">
            <div class="youTit">恭喜您</div>
            <!-- <div class="youTitip">获得新人随机1-9元专享红包</div> -->
            <div class="youTitip">获得新人随机20-50元专享红包</div>
            <div class="youTitMoBox">
              <div class="youTitRmb">¥</div>
              <div class="youTitNum">
                {{ youHuiqMoney }}
                <div class="TitNumheight" v-if="youHuiqMoney == 50">最高</div>
              </div>
              <div class="youTitRmb">元</div>
            </div>
          </div>
          <div class="getYouBtn" @click="getYouhuiMon(1)">开心收下</div>
        </div>
        <div class="youhuiBg">
        </div>
      </div>
      <!-- 19元优惠 -->
      <div class="payClosePop" id="youyipop1" v-show="secYouh">
        <div class="paySecBox">
          <div class="originBaoN">
            <div class="RMBIcon">￥</div>
            50
          </div>
          <img class="secYhImg" src="./images/payImg/yhSec.png" alt="">
          <div class="payTextTip">请务必珍惜，红包被翻倍的概率仅为 <span class="readOth">0.01%</span></div>
          <div class="payYouDetBox">
            <div class="youTitMoBox">
              <div class="secYouNum">
                <div class="RMBIcon">￥</div>
                {{ youHuiqMoneySec }}
                <div class="youheight" v-show="youHuiqMoneySec == 100">最高</div>

              </div>
            </div>
          </div>
          <div class="getYouBtn" @click="getYouhuiMon(2)">点击领取</div>
          <div class="secYouhTim">
            <div class="youTimBox">
              <div class="timBItem">{{ `${Math.floor(remainingTime1 / 60).toString().padStart(2, '0')}` }}</div>
              :
              <div class="timBItem">{{ `${(remainingTime1 % 60).toString().padStart(2, '0')}` }}</div>
              :
              <div class="timBItem">{{ peakerNum3 }}</div>
              优惠失效
            </div>
          </div>
          <div class="youhuiBg2">
          </div>
        </div>
      </div>
      <!-- <HdProvisionalUpgrade ref="hdProvref"></HdProvisionalUpgrade> -->
      <!-- 进入页面领取100 -->
      <div ref="couponPanel" v-if="couponShow" class="Popuppanel">
        <div class="coupon_panel">
          <div class="panel_header">
            <div class="red_line">恭喜您，获得新人专享幸运红包
            </div>
            <div class="gray_line">新用户首次专享升级会员福利</div>
            <!--            <div class="red_line">恭喜您，天降幸运红包</div>-->
            <!--            <div class="gray_line">新用户专享首次升级会员专享</div>-->
          </div>
          <div class="panel_content">
            <div class="coupon_line" v-for="item in coupon_list">
              <div class="line_left"><span class="coupon_unit">￥</span>{{ item.money }}</div>
              <div class="line_right">
                <div class="right_name">{{ item.tip }}</div>
                <div class="right_desc">仅限首次升级，过期作废</div>
              </div>
            </div>
            <button class="receive_btn" @click="couponClick('use')">开心收下</button>
            <div class="light_line" @click="couponClick('skip')">我不需要优惠，原价支持</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <HdProvisionalUpgrade ref="nisVip"></HdProvisionalUpgrade>
  <HdProvisionalMember ref="yisVip"></HdProvisionalMember> -->
</template>

<script type="text/ecmascript-6">
import utils from '@/utils/index.js'
// import HdProvisionalUpgrade from './HdProvisionalUpgrade.vue'
import QRCode from 'qrcode'
// that.$message.success('已为您下载图片，如下载失败，请右键保存或长按保存图片');

export default {
  // components: { HdProvisionalUpgrade },
  data() {
    return {
      ganxieList: [
        {
          id: 0,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "月费会员"
        },
        {
          id: 1,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "年费会员"
        }, {
          id: 2,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "月费会员"
        }, {
          id: 3,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "永久会员"
        }, {
          id: 4,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "月费会员"
        }, {
          id: 5,
          datetime: utils.getRandomTimeToday(),
          user_id: "2716**",
          vip_type: "季度会员"
        },
      ],
      youhuiMoney: 0,
      vipType: 4,
      curQuyShow: null,
      vipName: ['未开通', '月度会员', '季度会员', '年费会员', '终身会员'],
      couponShow: false,
      zongPay: 100,
      isYouhuiShow: false,
      isYouhuiShow2: false,
      coupon_list: [
        { money: 20, tip: '月费会员' },
        { money: 30, tip: '季度会员' },
        { money: 50, tip: '年费会员' },
        { money: 100, tip: '永久会员（终身）' },

      ],
      timerCategory: null,
      remainingTime: 600,
      remainingTime1: 600,
      peakerNum1: 99,
      peakerNum2: 10,
      peakerNum4: 10,
      peakerNum3: 99,
      timerRemaining: null,
      timerRemaining1: null,
      peakerNumList: [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
      peakerTimer1: null,
      peakerTimer2: null,
      isCompany: 0,
      payData:
      {
        pay_from: 'pc',
        is_company: 0,
        vip_type: 4,//vipType.value
        coupon_money: 0
      },
      payMoney: 0,
      moneyItem: '',
      chongzhiTime: null,
      curVipId: null,
      hdProvref: null,
      nisVip: null,
      yisVip: null,
      youHuiqMoney: 0,
      fisYouh: false,
      secYouh: false,
      youHuiqMoneySec: 0,
      youHeigShow: false,
      timer12: null,
      totalTime: 0,
      formattedTime: '10:00:00',
      payList: [],
      intervalId: null,
      isAgree:true,
      hide_vip_info:[],
      newpayHow:2,
    }
  },
  mounted() {
    //获取套餐列表
    this.getPayList()
    this.initZhongPay()
    if (localStorage.getItem('remainingShowTime')) {
      if (localStorage.getItem('remainingShowTime') == '00') {
        this.remainingTime = 0
      } else {
        this.remainingTime = parseInt(localStorage.getItem('remainingShowTime'))
      }
    } else {
      this.remainingTime = 600
    }
    if (localStorage.getItem('getY')) {
      this.couponShow = false
    } else {
      if (!this.userInfo.vip_type) {
        setTimeout(() => {
          this.couponShow = true
        }, 1000);
      }
    }
    this.intervalId = setInterval(this.updateTimer, 1000);
  },
  methods: {
        checkAgree(data){
      this.isAgree = data
    },
    paySuccessFn() {
                // this.$store.commit("setVipCongratulationsShow",true);
      // 支付成功
                //       this.$emit('succ_pay',{curVipId:this.curVipId})
                // this.$store.commit('setisPayPopShow', false)
      // clearInterval(this.chongzhiTime)
      // //this.userInfo.vip_type
      // if ([1, 2, 3].includes(this.userInfo.vip_type)) {
      //   clearInterval(this.chongzhiTime)
      //   console.log('支付成功>>' + this.userInfo);
      //   // chongzhi()
      //   this.$refs.hdProvref.setYouhui({ type: this.userInfo.vip_type, gr_lv: this.curVipId })
      //   this.$refs.hdProvref.setHdupShow(true)

      // } else {
      //   clearInterval(this.chongzhiTime)
      //   localStorage.removeItem('isTodyYouh')
      //   this.$refs.hdProvref.setyouHuiTpye(5)
      //   this.$refs.hdProvref.setHdupShow(false)
      // }
      // // emit('up_rig_sta')
      // this.$emit('up_rig_sta')

    },
    clearTimer2() {
      if (this.timerRemaining1) {
        clearInterval(this.timerRemaining1);
        this.timerRemaining1 = null;
      }
      if (this.peakerTimer2) {
        clearInterval(this.peakerTimer2);
        this.peakerTimer2 = null;
      }
    },
    updateTimer() {
      if (localStorage.getItem('totalTime')) {
        this.totalTime = localStorage.getItem('totalTime')
      } else {
        this.totalTime = 10 * 60 * 60
      }
      if (this.totalTime <= 0) {
        clearInterval(this.intervalId);
        this.formattedTime = '00:00:00';
        return;
      }
      const hours = Math.floor(this.totalTime / 3600);
      const minutes = Math.floor((this.totalTime % 3600) / 60);
      const seconds = this.totalTime % 60;
      this.formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      this.totalTime--;
      localStorage.setItem('totalTime', this.totalTime)
    },
    animateNumber(current, target, callback, time = 10) {
      let isIncreasing = current < target
      this.timer12 = setInterval(() => {
        if ((isIncreasing && current >= target) || (!isIncreasing && current <= target)) {
          clearInterval(this.timer12)
          return
        }

        current += isIncreasing ? 1 : -1
        callback(current)
      }, time)
    },
    startTimer2() {
      this.timerRemaining1 = setInterval(() => {
        if (this.remainingTime1 > 0) {
          // console.log(new Date().getSeconds())
          this.remainingTime1 -= 1;
        } else {
          this.clearTimer2();
        }
      }, 1000);
      this.peakerTimer2 = setInterval(() => {
        this.peakerNum3 -= 1
        this.peakerNumList.forEach((item, index) => {
          if (this.peakerNum2 === item) {
            // console.log('item>>'+ item)
            // console.log('peakerNum2>>'+ peakerNum2.value)
            this.peakerNum3 = Math.floor(Math.random() * (((item * 10) + 10) - (item * 10) + 1)) + (item * 10)
            this.peakerNum3 === 100 ? this.peakerNum3 - 1 : this.peakerNum3 <= 0 ? this.peakerNum3 + 1 : this.peakerNum3
            // peakerNum3.value = Math.floor((Math.random() * (item*10)))
            this.peakerNum3 < 10 ? this.peakerNum3 = '0' + this.peakerNum3 : this.peakerNum3
            // console.log('peakerNum1>>'+  peakerNum1.value)
            this.peakerNum4 === 0 ? this.peakerNum4 = 10 : this.peakerNum4
          }
        })
      }, 100)
    },
    tokefu() {
      // window.open(SITE_BTN_CONFIG.kefu_url.btn_value)
      utils.openKefu();
    },
    toInvoice() {
      // window.open(SITE_BTN_CONFIG.kefu_url.btn_value)
      utils.openKefu();
    },
    getListMoun(data) {
      if (this.userInfo.vip_type == 5) {
        return
      }
      let isyouhui = localStorage.getItem('paynum')
      if (isyouhui) {
        if (isyouhui == 1) {
          console.log(data[data.length - 1].pay_money);

          data[data.length - 1].pay_money = data[data.length - 1].pay_money - 50
        } else {
          data[data.length - 1].pay_money = data[data.length - 1].pay_money - 100
        }
      }
    },
    clearTimer() {
      if (this.timerRemaining) {
        clearInterval(this.timerRemaining);
        this.timerRemaining = null;
      }
      if (this.peakerTimer1) {
        clearInterval(this.peakerTimer1);
        this.peakerTimer1 = null;
      }
    },
    getPayList(data = 0) {
      this.$http.get('/front/aimj/pay/membership/', {
        params: {
          is_score: data
        }
      }).then(res => {
        console.log(res)
        // this.getListMoun(res.data.vip_info)
        this.moneyItem = res.data.vip_info[res.data.vip_info.length - 1]
        this.clearTimer();
        if(this.isCompany==0){
          this.hide_vip_info = res.data.hide_vip_info
        }
        if (localStorage.getItem('paynum') && this.isCompany == 0) {
          // 个人会员 且领取过 优惠券

          if (localStorage.getItem('paynum') == 1) {
            res.data.vip_info.forEach(item => {
              if (item.vip_type == 5) {
                if (!this.userInfo.vip_type) {
                  if (localStorage.getItem('getY')) {
                    item.pay_money = parseInt(item.pay_money) - item.coupon_money - 50
                  } else {
                    item.pay_money = parseInt(item.pay_money) - 50
                  }
                } else {
                  item.pay_money = parseInt(item.pay_money) - item.coupon_money - 50
                }
              } else {
                if (!this.userInfo.vip_type) {
                  if (localStorage.getItem('getY')) {
                    item.pay_money = parseInt(item.pay_money) - item.coupon_money
                  } else {
                    item.pay_money = parseInt(item.pay_money)
                  }
                } else {
                  item.pay_money = parseInt(item.pay_money) - item.coupon_money

                }
              }
            })
            this.isYouhuiShow = true
            this.startTimer()
          } else if (localStorage.getItem('paynum') == 2) {
            res.data.vip_info.forEach(item => {
              if (item.vip_type == 5) {
                if (!this.userInfo.vip_type) {
                  if (localStorage.getItem('getY')) {
                    item.pay_money = parseInt(item.pay_money) - item.coupon_money - 100
                  } else {
                    item.pay_money = parseInt(item.pay_money) - 100
                  }
                } else {
                  item.pay_money = parseInt(item.pay_money) - item.coupon_money - 100
                }
              } else {
                if (!this.userInfo.vip_type) {
                  if (localStorage.getItem('getY')) {
                    item.pay_money = parseInt(item.pay_money) - item.coupon_money
                  } else {
                    item.pay_money = parseInt(item.pay_money)
                  }
                } else {
                  item.pay_money = parseInt(item.pay_money) - item.coupon_money
                }
              }
            })
            // res.data.vip_info[res.data.vip_info.length - 1].pay_money = parseInt(res.data.vip_info[res.data.vip_info.length - 1].pay_money) - 10
            this.isYouhuiShow = true
            this.isYouhuiShow2 = true
            this.startTimer()
          }
        } else if ((localStorage.getItem('getY') && this.isCompany == 0) || this.userInfo.vip_type) {
          // 个人会员领取过 通用 优惠券
          res.data.vip_info.forEach(item => {
            item.pay_money = parseInt(item.pay_money) - item.coupon_money
          })
          this.startTimer()
        }
        this.$nextTick(()=>{
        this.payList = res.data.vip_info
        })
        this.payMoney = res.data.vip_info[res.data.vip_info.length - 1].pay_money
        this.vipType = res.data.vip_info[res.data.vip_info.length - 1].vip_type
        this.payData.vip_type = this.vipType
        if (localStorage.getItem('paynum') && !this.isCompany) {
          if (localStorage.getItem('paynum') == 1) {
            this.curVipId = 'level_5'
            res.data.vip_info[res.data.vip_info.length - 1] = res.data.hide_vip_info[0]
            this.zongPay = 150
          } else {
            this.curVipId = 'level_6'
            res.data.vip_info[res.data.vip_info.length - 1] = res.data.hide_vip_info[1]
            this.zongPay = 200
          }
        } else {
          if (!this.isCompany) {
            this.curVipId = 'level_4'
          } else {
            this.curVipId = res.data.vip_info[res.data.vip_info.length - 1].vip_type
          }
        }
        if (localStorage.getItem('isTody') && !this.isCompany) {
          this.payData.is_upgrade = 1
        } else {
          this.payData.is_upgrade = 0
        }
        this.chongzhi()

      })
    },
    chongzhi() {
      clearInterval(this.chongzhiTime)
      this.payData.appid = APP_ID
      this.payData.pay_source = "pc"
      this.payData.vip_id = this.curVipId
      this.payData.pro_type = this.isCompany ? 1 : 0

      this.$http.post('/front/aimj/pay/chongzhi/', this.payData).then(res => {
        console.log(res);
        // this.$nextTick(() => {
        var canvas = document.getElementById('canvas')
        QRCode.toCanvas(canvas, res.data.pay_url, function (error) {
          if (error) console.error(error)
        })
        // })
        this.chongzhiSta(res.data.uniq_key)
      }).catch(err => {
        console.log('错误');

        console.log(err);

      })
    },
    chongzhiSta(data) {
      this.$http.get(`/pay/order/status/?uniq_key=${data}`).then((res) => {
        if (res.data.code) {
          clearInterval(this.chongzhiTime)
          // store.dispatch('getUserInfo')
          this.$http.get(`/front/user/profile/`).then(res => {
          this.$store.commit('setUserInfo',res.data)
            if (!this.isCompany) {
              setTimeout(() => {
                // this.$emit('succ_pay',{curVipId:this.curVipId})
                this.$store.commit('setisPayPopShow', false)
                //恭喜成为xxx弹窗
                this.$store.commit('setVipCongratulationsShow', true) 
                // this.paySuccessFn()
              })
            } else {
              this.$message.success('购买积分包成功！')
              this.$store.commit('setisPayPopShow', false)
            }
          })
        } else {
          clearInterval(this.chongzhiTime)
          this.chongzhiTime = setInterval(() => {
            this.chongzhiStaFn(data)
          }, 3000);
        }
      })
    },
    chongzhiStaFn(data) {
      this.$http.get(`/pay/order/status/?uniq_key=${data}`).then((res) => {
        if (res.data.code) {
          this.$http.get(`/front/user/profile/`).then(res => {
            if (res.status == 200) {
              clearInterval(this.chongzhiTime)
              this.$store.commit('setUserInfo', res.data)
              if (!this.isCompany) {
                setTimeout(() => {
                  // this.paySuccessFn()
                // this.$emit('succ_pay',{curVipId:this.curVipId})
                this.$store.commit('setisPayPopShow', false)
                //恭喜成为xxx弹窗
                this.$store.commit('setVipCongratulationsShow', true) 
                })
              } else {
                this.$message.success('购买积分包成功！')
                this.$store.commit('setisPayPopShow', false)
              }
            }
          })
        }
      })
    },
    changePayTye(data) {
        this.initZhongPay()
        this.isCompany = data
        this.getPayList(data)
    },
    initZhongPay(){
  if (localStorage.getItem('paynum')) {
    if (localStorage.getItem('paynum') == 1){
      this.zongPay = 150
    }else{
      this.zongPay = 200
    }
  }else{
    this.zongPay = 100
  }
  // zongPay.value = 100
},
    selectPay(item) {
      // 充值档位选择
      console.log('充值挡位');
      console.log(item);

      this.moneyItem = item
      this.vipType = item.vip_type
      this.payMoney = item.pay_money
      this.payData.vip_type = item.vip_type
      this.zongPay = item.coupon_money
      // getYouHuiMoney()
      // payData.coupon_money = youhuiMoney
      clearInterval(this.timer12)
      if (item.vip_type == 5) {

        if (localStorage.getItem('paynum') && !this.isCompany) {
          if (localStorage.getItem('paynum') == 1) {
            this.curVipId = 'level_5'
            this.payList[this.payList.length - 1] = this.hide_vip_info[0]
            this.zongPay = 150
            this.payMoney = 149
          } else {
            this.curVipId = 'level_6'
            this.payList[this.payList.length - 1] = this.hide_vip_info[1]
            this.zongPay = 200
            this.payMoney = 99
          }
        } else {
          if (!this.isCompany) {
            this.curVipId = 'level_4'
          } else {
            this.curVipId = item.vip_type
          }
        }
        if (localStorage.getItem('isTody') && !this.isCompany) {
          this.payData.is_upgrade = 1
        } else {
          this.payData.is_upgrade = 0
        }
      } else {
        if (!this.isCompany) {
          this.curVipId = item.vip_id
        } else {
          this.curVipId = item.vip_type
        }
      }

      clearInterval(this.chongzhiTime)
      this.chongzhi()
      // setYouhui({type:payData.vip_type})
    },
    //领取优惠券
    getYouhuiMon(data) {
      if (data == 1) {
        setTimeout(() => {
          this.fisYouh = false
        }, 1000);
        let youyi = document.querySelector('#youyipop')
        youyi.classList.add('payClosePopShou')
        this.payList.forEach(item => {
          if (item.vip_type == 5) {
            item.privilege = this.hide_vip_info[0].privilege
            utils.animateNumber(parseInt(item.pay_money), parseInt(item.pay_money) - 50, (newValue) => {
              item.pay_money = newValue
            }, 50)
          }
        })
        if (this.vipType == 5) {
          this.curVipId = 'level_5'
          // this.payList[this.payList.length - 1] = this.hide_vip_info[0]
          this.zongPay = 150
          this.animateNumber(parseInt(this.payMoney), parseInt(this.payMoney) - 50, (newValue) => {
            console.log(newValue)
            this.payMoney = newValue
          }, 50)
        }
        setTimeout(() => {
          this.isYouhuiShow = true
        }, 1000);
        // youhuiMoney.value = 9
        localStorage.setItem('isTodyYouh', JSON.stringify({ time: Date.now() }))
        // this.getYouHuiMoney()
        this.clearTimer();
        this.startTimer()
      } else {
        clearInterval(this.timer12)
        setTimeout(() => {
          this.secYouh = false
        }, 1000);
        localStorage.setItem('paynum', 2)
        // youhuiMoney.value = 19
        let youyi = document.querySelector('#youyipop1')
        youyi.classList.add('payClosePopShou1')
        // this.getYouHuiMoney()
        this.clearTimer2()
        setTimeout(() => {
          this.isYouhuiShow2 = true
        }, 1000);

        this.payList.forEach(item => {
          if (item.vip_type == 5) {
            item.pay_money = 149
            item.privilege = this.hide_vip_info[1].privilege
            // if (vipType.value == 4) {
            // 终身会员
            utils.animateNumber(item.pay_money, item.pay_money - 50, (newValue) => {
              item.pay_money = newValue
            }, 50)
            // }
          }
        })
        if (this.vipType == 5) {
          this.curVipId = 'level_6'
          // this.payList[this.payList.length - 1] = this.hide_vip_info[1]
          this.zongPay = 200
          this.animateNumber(parseInt(this.payList[this.payList.length - 1].pay_money), parseInt(this.payList[this.payList.length - 1].pay_money) - 50, (newValue) => {
            this.payMoney = newValue
          }, 50)
        }
      }
      // selectPay(payList.value[vipType.value - 1])
      this.chongzhi()
    },
    couponClick() {
      // 领取200优惠券
      this.couponShow = false
      this.timerCategory = setInterval(() => {
        clearInterval(this.timerCategory)
      }, 10)
      this.payList.forEach(item => {
        utils.animateNumber(parseInt(item.pay_money), parseInt(item.pay_money) - item.coupon_money, (newValue) => {
          item.pay_money = newValue
        }, 10)
      })
      utils.animateNumber(parseInt(this.payMoney), parseInt(this.payMoney) - 100, (newValue) => {
        this.payMoney = newValue
      }, 10)

      localStorage.setItem('getY', true)
    },
    closePayPop() {
      clearInterval(this.intervalId);

      // this.$store.commit('setremaTimer') 
      if (this.isCompany == 1 || this.userInfo.vip_type == 5) {
        // 企业会员
        this.$store.commit('setisPayPopShow', false)
        clearInterval(this.chongzhiTime)
        //判断加桌
        if(utils.getIsZeroTime('addDeskTime')){
          this.$emit('addDesk')
        }
        return
      }
      let paynum = localStorage.getItem('paynum')
      if (paynum) {
        if (paynum == 2) {//关闭
          let payPopEl = document.querySelector('#paydongPop')
          payPopEl.classList.add('paynewBoxDon')
          //判断加桌
          if(utils.getIsZeroTime('addDeskTime')){
            this.$emit('addDesk')
          }
          setTimeout(() => {
            payPopEl.classList.remove('paynewBoxDon')
            this.$store.commit('setisPayPopShow', false)
            // store.commit('setremainingShow', true)
            localStorage.setItem('remainingShowTime', this.remainingTime)
            clearInterval(this.chongzhiTime)
            if (this.userInfo.vip_type) {
              this.$http.get('/front/aimj/pay/today_order/').then(res => {
                if (res.status == 200) {
                  // payKeStore.showVipTime(true)
                  this.$store.commit('showVipTime', true)
                  this.$store.commit('setVipYouhuiHeaderShow', true)
                  let localTime = localStorage.getItem('heade_r_show')
                  if(localTime){
                    // 10分钟过期
                    if (Date.now() - localTime >= 10*60*1000) {
                      // this.$store.commit('setVipYouhuiHeaderShow',)
                      this.$store.commit('setHeader_r_show',1)
                    }else{
                      this.$store.commit('setHeader_r_show',2)
                    }
                  }

                }
                if (res.status == -1) {
                  // payKeStore.showVipTime(false)
                  this.$store.commit('showVipTime', false)
                }
                if(res.status==401){
                  throw new Error(`HTTP status ${res.status}`)
                      // throw res
                }
              }).catch(err => {
                localStorage.setItem('isTodyYouh', JSON.stringify({ time: Date.now() }))
                // payKeStore.showVipTime(true)
                this.$store.commit('showVipTime', true)
              })
            } else {
              localStorage.setItem('isTodyYouh', JSON.stringify({ time: Date.now() }))
              // payKeStore.showVipTime(true)
              this.$store.commit('showVipTime', true)
              this.$store.commit('setVipYouhuiHeaderShow', true)


              let kehuInfo = localStorage.getItem('isTodyYouh')
              if (kehuInfo) {
                kehuInfo = JSON.parse(kehuInfo)
                let start_time = kehuInfo.time
                const STORAGE_KEY = 'isTodyYouh';
                const TWELVE_HOURS = 12 * 60 * 60 * 1000; // 12小时的毫秒数
                const TWELVE_HOURS2 = 168 * 60 * 60 * 1000; // 7天的毫秒数

                const currentTime = Date.now();

                // 计算时间差
                const timeDiff = currentTime - parseInt(start_time, 10);
                let clientDownDate = localStorage.getItem('isTodyYouh') || 0
                // 超过12小时执行操作
                if ((timeDiff >= TWELVE_HOURS) && !clientDownDate) {
                  // payKeStore.showVipTime(false)
                  this.$store.commit('showVipTime', false)
                  // localStorage.removeItem('isTodyYouh')
                } else {
                  // payKeStore.showVipTime(true)      
                  this.$store.commit('showVipTime', true)
                }
              } else {
                localStorage.setItem('isTodyYouh', JSON.stringify({ time: Date.now() }))
                // payKeStore.showVipTime(true)
                this.$store.commit('showVipTime', true)

              }
            }
          }, 1000);

        } else {
          this.secYouh = true
          // this.animateValue(90,100,4000)

          utils.animateNumber(50, 100, (newValue) => {
            console.log(newValue)
            this.youHuiqMoneySec = newValue
            if (this.youHuiqMoneySec == 100) {
              this.youHeigShow = true
            }
          }, 20)

          this.startTimer2()
        }
      } else {
        localStorage.setItem('paynum', 1)
        this.fisYouh = true
        let timer = null
        timer = setInterval(() => {
          this.youHuiqMoney = utils.getRandomInt(20, 49)
        }, 200);
        setTimeout(() => {
          clearInterval(timer)
          this.youHuiqMoney = 50
        }, 3000);
      }
      if (localStorage.getItem('paynum') == 2) {
        // store.commit('setYouhuiHeaderShow', true)
      }
    },
    toXieyi() {
      window.open('https://docs.qq.com/doc/p/69c5bcfc16e65ce567757b7ee572db9bdfe06b2f')
    },
    startTimer() {
      this.timerRemaining = setInterval(() => {
        if (this.remainingTime > 0) {
          // console.log(new Date().getSeconds())
          if (localStorage.getItem('remainingShowTime')) {
            this.remainingTime = parseInt(localStorage.getItem('remainingShowTime'))
          }
          this.remainingTime -= 1;
          if (this.remainingTime <= 0) {
            localStorage.setItem('remainingShowTime', 0)
          } else {
            localStorage.setItem('remainingShowTime', this.remainingTime)
          }
        } else {
          this.clearTimer();
          this.remainingTime = "00"
          this.peakerNum1 = "00"
        }
      }, 1000);
      this.peakerTimer1 = setInterval(() => {
        this.peakerNum2 -= 1
        this.peakerNumList.forEach((item, index) => {
          if (this.peakerNum2 === item) {
            console.log('执行');

            // if(peakerNum2.value==1){
            //   peakerNum1.value = '00'
            // }else{
            this.peakerNum1 = Math.floor(Math.random() * (((item * 10) + 10) - (item * 10) + 1)) + (item * 10)
            this.peakerNum1 === 100 ? this.peakerNum1 - 1 : this.peakerNum1 <= 0 ? this.peakerNum1 + 1 : this.peakerNum1
            this.peakerNum1 < 10 ? this.peakerNum1 = '0' + this.peakerNum1 : this.peakerNum1
            this.peakerNum2 === 0 ? this.peakerNum2 = 10 : this.peakerNum2
            // }

          }
        })
      }, 100)
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isPayPopShow() {
      return this.$store.state.isPayPopShow;
    }
  }
}

</script>

<style lang="scss" scoped>
.paynewBox {
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  font-size: 14px !important;

  .payBoxCon {
    width: 1100px;
    // height: 580px;
    background: #fff;
    transform-origin: center;
    /* 设置缩放中心点为元素中心 */
    animation: scaleIn 1s ease-out forwards;
    /* 应用动画 */
  }

  @keyframes scaleIn {
    0% {
      transform: scale(0);
      /* 开始时完全缩小 */
      opacity: 0;
      /* 可选：开始时完全透明 */
    }

    100% {
      transform: scale(1);
      /* 结束时正常大小 */
      opacity: 1;
      /* 可选：结束时完全不透明 */
    }
  }

  .payHeader {
    width: 100%;
    height: 80px;
    // background: #fc7171;
    // background: linear-gradient(to right, #ff623f, #ff77a8);
    background: url('./images/payImg/banner_10_year.jpg') no-repeat;
    background-size: cover;
    display: flex;
    justify-content: space-between;

    .payLeftBox {
      display: flex;
      align-items: center;

      // width: 520px;
      .payUIc {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #fff;
        margin: 0 20px;

        .payUIcImg {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      .payUDet {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        // justify-content: space-between;
        // justify-content: space-around;
        // padding: 15px 0 10px;

        .payUName {
          // line-height: 0;
          display: flex;
          align-items: center;
          //   margin-top: 8px;

          .payname {
            font-size: 16px;
            color: #fff;
          }

          .paySty {
            height: 18px;
            font-size: 12px;
            background: #ffe776;
            border-radius: 5px;
            margin-left: 10px;
            color: #ff6b3b;
            padding: 0 3px;
          }
        }

        .payUInfo {
          display: flex;
          margin-top: 5px;

          .infoItem {
            display: flex;
            align-items: center;
            margin-right: 20px;

            .iIname {
              color: #fff;
              font-size: 14px;
            }

            .iIData {
              color: #fff;
              font-size: 14px;
            }

            .iIDataOth {
              color: #ffe776;
            }
          }
        }
      }
    }

    .payRightBox {
      flex: 1;
      // background: #afe715;
      display: flex;
      justify-content: flex-end;
      position: relative;

      .closePayBtn {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;

        .payCloseIm {
          width: 12px;
          height: 12px;
          font-size: 0;
        }
      }

      .payMenu {
        height: 100%;
        display: flex;
        align-items: end;
        padding-bottom: 20px;

        .payMitem {
          color: #fff;
          font-size: 14px;
          margin: 0 10px;
          cursor: pointer;
        }
      }
    }
  }

  .payContent {
    width: 100%;
    height: calc(100% - 60px - 50px);
    padding-top: 30px;
    // background: #ccc;
    position: relative;

    .isVipMask {
      width: 101%;
      height: 455px;
      // background: rgba(0,0,0,.6);
      background: #fff;
      position: absolute;
      bottom: 20px;
      left: -3px;
      z-index: 99;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      z-index: 500;

      .isEveTips {
        cursor: pointer;
      }
    }

    .paySelect {
      display: flex;
      justify-content: center;
      // background: #ccc;
      height: 30px;
      // flex-shrink: 0;

      .payItem {
        margin: 0 50px;
        position: relative;
        cursor: pointer;
        color: #666666;
        display: flex;
        align-items: center;
        flex-shrink: 0;

        .jifenList {
          position: absolute;
          right: -90px;
          top: 6px;
          display: flex;
          align-items: center;

          .jifenItem {
            font-size: 12px;
            color: #fa4828;
            background: #fdc1b7;
            border-radius: 2px;
            padding: 2px 5px;
            margin-left: -3px;
            white-space: nowrap;
            font-weight: 400;
            transform: scale(0.8);
          }
        }

        .payHot {
          position: absolute;
          right: -36px;
          top: -12px;
        }

        .payItemAcI {
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          width: 30px;
          height: 2px;
          background: #ff4444;
        }
      }

      .payItemother {
        margin-left: 80px;
      }

      .payItemAct {
        color: #ff4444;
        font-weight: 700;
      }
    }

    .payList {
      width: 100%;
      height: 220px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      margin-top: 30px;
      gap: 0 25px;
      position: relative;

      .payQuyiLsit {
        position: absolute;
        top: 210px;
        left: -1px;
        width: calc(100% + 2px);
        height: 350px;
        z-index: 99;
        background: #fff;
        color: #ccc;
        font-size: 14px;
        border: 1px solid #efefef;
        animation: expand 0.5s forwards;
        /* 应用动画 */
        border-top: none;
        overflow: hidden;
        line-height: 24px;
        padding: 0 1px;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;

        .payqyItem {
          margin: 5px 0;
        }

        @keyframes expand {
          from {
            height: 0;
          }

          to {
            height: 125px;
          }
        }
      }

      .payQuyiLsitOther {
        color: #666;
        border: 1px solid #ffd0d0;
        border-top: none;

      }

      .payTypeItem {
        background: #fff;
        border: 1px solid #efefef;
        text-align: center;
        background: url('./images/payImg/payTybg.png') no-repeat;
        background-size: cover;
        cursor: pointer;
        position: relative;
        border-radius: 4px;
        color: #000;

        .evePayTimer {
          width: 100%;
          height: 32px;
          background: linear-gradient(to right, #fabc8f, #e53291);
          position: absolute;
          left: 0;
          bottom: -32px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
        }

        .favorite {
          position: absolute;
          right: -7px;
          top: -12px;
          width: 97px;
          height: 32px;
          background-image: url("./images/payImg/img_icon_64.png");
          background-size: 100% 100%;
          font-size: 12px;
          color: #fff;
          line-height: 25px;
        }

        .payTyTit {
          margin: 25px 0 20px;
          color: #666666;
          font-weight: 600;
        }

        .payTynum {
          display: flex;
          justify-content: center;
          align-items: baseline;

          .payNumber {
            font-size: 30px;
            font-weight: 600;
            margin-left: 10px;
          }
        }

        .payTyTips {
          font-size: 14px;
          color: #ccc;
          margin-top: 15px;
          display: flex;
          align-items: center;
          justify-content: center;

          .payTqyTipImg {
            width: 16px;
            height: 16px;
            margin-left: 5px;
          }
        }

        .payDayTip {
          color: #ccc;
          margin-top: 20px;
        }

        .payYes {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 30px;
          height: 30px;
          z-index: 100;
        }

        .discount_box {
          position: absolute;
          right: -5px;
          top: -10px;
          width: 70px;
          height: 28px;
          background-size: 100% 100%;
          font-size: 12px;
          line-height: 20px;
          white-space: nowrap;

          &.bgi1 {
            background-image: url("./images/payImg/img_icon_64.png");
            color: #fff;

          }

          &.bgi2 {
            background-image: url("./images/payImg/img_icon_65.png");
            color: #666;
          }
        }

      }

      .payTypeItemAct {
        background: url('./images/payImg/payTybgAc.png') no-repeat;
        background-size: cover;
        border: 1px solid #ffd0d0;

        .payTyTit {
          color: #333;
        }

        .payTyTips {
          color: #666;
        }
      }
    }

    // .payListOther{
    //   grid-template-columns: repeat(5, 1fr);
    //   gap: 0 20px;

    // }

    .top_bor {
      border-top: 1px dashed #ccc;
      margin: 40px 0 0;
    }

    .payDataDetail {
      width: 100%;
      //height: 170px;
      // background: #ccc;
      // display: grid;
      // grid-template-columns: repeat(2, 1fr);
      display: flex;
      //   justify-content: space-between;
      padding: 30px 0 30px;
      // margin-top: 40px;


      // gap: 0 20px;
      .payCode {
        width: 140px;
        height: 140px;
        // background: #ff77a8;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .payCodImg {
          width: 140px !important;
          height: 140px !important;
        }

        .paySuccess {
          position: absolute;
          top: -20px;
          left: 10px;
          cursor: pointer;
        }

        &:before,
        &:after,
        .jiao:before,
        .jiao:after {
          content: "";
          display: block;
          position: absolute;
          width: 24px;
          height: 24px;
          border: 2px solid #e22222;
        }

        &:before {
          top: -2px;
          left: -2px;
          border-right: none;
          border-bottom: none;
        }

        &:after {
          top: -2px;
          right: -2px;
          border-left: none;
          border-bottom: none;
        }

        .jiao:before {
          bottom: -2px;
          left: -2px;
          border-right: none;
          border-top: none;
        }

        .jiao:after {
          bottom: -2px;
          right: -2px;
          border-left: none;
          border-top: none;
        }

        .time_out_cover {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 5;
          cursor: pointer;
          background-color: rgba(0, 0, 0, 0.78);
          color: #fff;
          font-size: 14px;
          z-index: 10;

          &:hover {
            font-size: 15px;
            font-weight: bold;
          }

          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .paydetailList {
        width: 1000px;
        height: 140px;
        // background: #38458b;
        display: flex;
        flex-direction: column;
        // justify-content: space-between;
        position: relative;
        font-size: 14px;
        margin-left: 20px;

        .payMoney {
          position: relative;
          // background: #000;
          color: #000;
          margin-top: -10px;

          .payIC {}

          .payMone {
            font-size: 24px;
            font-weight: 600;
            margin: 0 8px;
          }

          .payTipsBox {
            position: absolute;
            top: 50%;
            transform: translateY(-40%);
            display: flex;

            &.pos_l168 {
              left: 168px;
              // right: 0;
            }

            &.pos_l179 {
              left: 179px;
            }

            .one_right {
              color: #e22222;
              display: flex;
              white-space: nowrap;

              &.invoice {
                margin-left: 5px;
              }

              .one_right_money {
                margin-right: 12px;
                display: flex;
                align-items: flex-end;
                margin-bottom: 4px;
              }

              .right_bgc {
                position: relative;
                background-color: #fad6d6;
                padding: 3px 8px;
                border-radius: 3px;

                div {
                  position: absolute;
                  top: 9px;
                  left: -3px;
                  width: 10px;
                  height: 10px;
                  background-color: #fad6d6;
                  color: #fff;
                  transform: rotate(45deg);
                }
              }

            }

            .one_oth_le {
              margin-left: 240px;
            }

            .one_oth_le2 {
              margin-left: 229px;
            }

            .one_oth_le3 {
              margin-left: 110px;
            }

          }

        }

        .line_cen {
          color: #b2aabd;
          margin-top: 20px;
          display: flex;
          align-items: center;
        }
                .new_line_pay{
          display: flex;
          // justify-content: space-between;
          margin-top: 20px;
          position: relative;
          .zhixiangbox{
              position: absolute;
              bottom: -45px;
              left: 16px;
              width: 260px;
              height: 40px;
              // background: #ccc;
              display: flex;
              align-items: center;
                            .zhiRowImg {
                width: 22px !important;
                height: 20px !important;
                align-self: flex-start;
              }

              .tuijainzhizfb {
                // border: 1px solid #009be3;
                // background: #d3eefb;
                // border-radius: 4px;
                padding: 2px 6px;
                color: #5ec0ed;
              }
          }
          .lin_pay_item{
            width: 150px;
            height: 30px;
            border: 1px solid #ccc;
            border-radius: 4px;
            display: flex;
            align-items: center;
            position: relative;
            cursor: pointer;
            .selIcimg{
              width: 20px;
              height: 20px;
              position: absolute;
              right: -1px;
              bottom: -1px;
            }
            .pay_icon{
              width: 15px;
              height: 15px;
              margin: 0 10px;
            }
          }
          .lin_pay_item_bao{
            color: #009be3;
            border: 1px solid #009be3;
            // background: #dbf2fc;
          }
          .lin_pay_item_wei{
            color: #09bb07;
            border: 1px solid #09bb07;
            margin-left: 20px;
          }
          .lin_payact_bao{
            background: #dbf2fc;
          }
          .lin_payact_wei{
            background: #d8ffdb;
          }
        }

        .argumentPay {
          color: #b2aabd;
          cursor: pointer;
          margin-top: 65px;
          width: 230px;
                    display: flex;
          align-items: center;
          .argCheBox{
            width: 14px;
            height: 14px;
            border-radius: 2px;
            border: 1px solid #ccc;
            margin-right: 5px;
          }
                    .argCheYes{
            width: 15px;
            height: 15px;
            margin-right: 4px;
          }
        }

        .pay_type {
          padding: 0 10px;

          &.wx_pay {
            color: #09bb07;
          }

          &.ali_pay {
            color: #009be3;
            position: relative;

            .zhixiangbox {
              position: absolute;
              bottom: -45px;
              left: 16px;
              width: 260px;
              height: 40px;
              // background: #ccc;
              display: flex;
              align-items: center;

              .zhiRowImg {
                width: 22px !important;
                height: 20px !important;
                align-self: flex-start;
              }

              .tuijainzhizfb {
                border: 1px solid #009be3;
                background: #d3eefb;
                border-radius: 4px;
                padding: 2px 6px;
              }
            }
          }

          .pay_icon {
            vertical-align: middle;
            margin: -2px 8px 0 0;
            width: 16px;
          }
        }

        .payYouhui {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 260px;
          height: 70px;
          background: linear-gradient(to right, #ff6364, #ff8056);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .youhuiLeft {
            width: 78px;
            height: 60px;
            // background: #000;
            margin-left: 5px;
            text-align: center;
            color: #fff;

            .youhuiMoney {
              display: flex;
              justify-content: center;
              align-items: baseline;
              margin-top: 5px;

              .youRmb {
                font-weight: 600;
              }

              .youMNum {
                font-size: 24px;
                font-weight: 600;
              }
            }

            .youhuiTip {
              font-size: 12px;
            }

            .youhuiTip1 {
              white-space: nowrap;
            }
          }

          .youhuiRig {
            color: #fff;
            text-align: center;

            .youT {
              font-size: 12px;
            }

            .youTimBox {
              display: flex;
              align-items: center;
              font-size: 12px;
              margin-right: 10px;
              margin-top: 10px;
              // color: #000;

              .timBItem {
                background: rgba(255, 255, 255, .3);
                font-size: 13px;
                padding: 0 2px;
                margin: 0 5px;
                border-radius: 3px;
                line-height: 16px;

              }
            }
          }

          .youSelIc {
            position: absolute;
            left: 5px;
            top: 5px;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;

            .yesImg {
              width: 100%;
              height: 100%;
              font-size: 0;
            }
          }

          .mskPorin {
            width: 12px;
            height: 15px;
            // border-radius: 10px;
            border-radius: 50%;
            background: #fff;
            position: absolute;
            left: 84px;
            top: -8px;
          }

          .mskPorin1 {
            left: 82px;
            top: -8px;
          }

          .mskPorin2 {
            left: 82px !important;
            bottom: -8px !important;
          }

          .mskPorinOth {
            width: 12px;
            height: 15px;
            border-radius: 50%;
            background: #fff;
            position: absolute;
            left: 84px;
            bottom: -9px;
          }

          .mskLine {
            width: 2px;
            height: 65%;
            background: rgba(255, 255, 255, 0.2);
            position: absolute;
            left: 90px;
            top: 50%;
            border-radius: 2px;
            transform: translateY(-50%);
          }

          .youhuiLeft2 {
            position: absolute;
            width: 90px;
            height: 70px;
            left: -90px;
            top: 0;
            background: #ff6364;
            border-radius: 8px;

            // margin-left: 5px;
            .youhuiLeft {
              width: 60px;
              height: 60px;
              // background: #000;
              margin-left: 5px;
              text-align: center;
              color: #fff;

              .youhuiMoney {
                margin-top: 10px;
              }

              .youhuiMoney {
                margin-left: 10px;
              }
            }
          }

          .mskLine1 {
            left: 87px;
          }
        }
      }

    }
  }

  .payFoot {
    height: 50px;
    // background: #5bb3ee;
    border-top: 1px solid #ebebeb;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .pfLbox {
      color: #666666;
    }

    .pfRbox {
      display: flex;
      // align-items: end;
      align-items: center;
      justify-content: space-between;
      color: #666666;
      // width: 570px;
      width: 501px;

      .el-carousel {
        width: 80%;
      }

      .pfletter {
        width: 20px;
        height: 20px;
        font-size: 0;
      }

      .lettTit {
        color: transparent;
        background-image: linear-gradient(to right, #ff7b95, #ff1be8);
        -webkit-background-clip: text;
        background-clip: text;
        // margin-left: 10px;
      }

      .lrScro {
        margin: 0 10px;
      }

      .lScro {
        margin-left: 10px;
      }

      .payTime {
        color: #ff6463;
      }

    }
  }

  .payMainSty {
    width: 94%;
    margin: 0 auto;
  }

  .payClosePop {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 500;

    .youhuiBg {
      position: absolute;
      left: 0;
      top: 0;
      // transform: translate(-50%,-50%);
      z-index: 1;
      background: url('./images/payImg/youhuiBg.png') no-repeat;
      width: 500px;
      height: 500px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation: spin 2s linear infinite;
    }

    @keyframes spin {
      from {
        transform: translate(-50%, -50%) rotate(30deg);
        transform-origin: center;
      }

      to {
        transform: translate(-50%, -50%) rotate(360deg);
        transform-origin: center;
      }
    }

    .payFirBox,
    .paySecBox {
      position: relative;
      z-index: 2;
      animation: slide-fwd-center 0.45s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;

      .originBaoN {
        position: absolute;
        left: 66px;
        top: 181px;
        display: flex;
        align-items: baseline;
        color: #e22222;
        font-size: 40px;
        z-index: 99;

        .RMBIcon {
          font-size: 20px;
        }
      }

      .getYouBtn {
        width: 175px;
        height: 45px;
        // background: rgba(255,255,255,0.5);
        position: absolute;
        bottom: 68px;
        left: 49%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        // text-align: center;
        justify-content: center;
        cursor: pointer;
        color: #000;
        font-weight: 600;
        font-size: 16px;
      }

      .secYouhTim {
        // background: #ccc;
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
        color: #000;

        .youTimBox {
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-right: 10px;
          margin-top: 10px;

          .timBItem {
            background: rgba(255, 255, 255, .3);
            font-size: 13px;
            padding: 0 2px;
            margin: 0 5px;
            border-radius: 3px;
            line-height: 16px;

          }
        }
      }

      .payTextTip {
        position: absolute;
        left: 12%;
        top: 80px;
        // background: #000;
        color: #785c48;

        .readOth {
          color: #e84c2a;
        }
      }

      .payYouDetBox {
        width: 220px;
        // height: 100px;
        // background: rgba(255,255,255,0.8);
        position: absolute;
        left: 49%;
        top: 60px;
        transform: translateX(-50%);
        text-align: center;

        .youTit {
          font-size: 20px;
          color: #e22222;
          font-weight: 600;
        }

        .youTitip {
          margin: 20px 0;
          color: #000;
        }

        .youTitMoBox {
          display: flex;
          align-items: baseline;
          justify-content: center;
          position: relative;

          .youTitNum {
            font-size: 56px;
            font-weight: 800;
            margin: 0 15px;
            color: #e22222;

            .TitNumheight {
              position: absolute;
              right: 35px;
              top: -9px;
              background: #e24c38;
              color: #fff;
              font-size: 14px;
              width: 40px;
              height: 22px;
              border-top-left-radius: 22px;
              border-bottom-right-radius: 22px;
              border-top-right-radius: 22px;
            }
          }

          .youTitRmb {
            font-size: 20px;
            font-weight: 600;
            color: #e22222;
          }
        }

      }

    }

    .paySecBox {
      .payYouDetBox {
        width: 50px;
        height: 50px;
        // background: #ccc;
        left: 61%;
        top: 150px;
        transform: translateX(50%);
        display: flex;
        align-items: center;
        justify-content: center;

        .secYouNum {
          font-size: 40px;
          color: #e73b2a;
          position: relative;
          display: flex;
          align-items: baseline;
          margin-left: -15px;

          .RMBIcon {
            font-size: 20px;
          }

          .youheight {
            position: absolute;
            right: -12px;
            top: -24px;
            background: #e24c38;
            color: #fff;
            font-size: 14px;
            width: 40px;
            height: 22px;
            border-top-left-radius: 22px;
            border-bottom-right-radius: 22px;
            border-top-right-radius: 22px;
          }
        }
      }

      .getYouBtn {
        width: 320px;
        height: 50px;
        // background: rgba(255,255,255,0.5);
        position: absolute;
        bottom: 88px;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
        font-weight: 500;
      }

      .secYhImg {
        // width: 320px;
      }

      .youhuiBg2 {
        position: absolute;
        left: -20px;
        top: -120px;
        width: 110%;
        height: 150px;
        z-index: 1;
        background: url('./images/payImg/youhuiyh.gif') no-repeat;
        background-size: cover;
        // background: #000;
      }
    }

    @keyframes slide-fwd-center {
      0% {
        transform: scale(0);
      }

      100% {
        transform: scale(1);
      }
    }
  }

  .payClosePopShou {
    background: rgba(0, 0, 0, 0);
    -webkit-animation: slide-bck-br 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
    animation: slide-bck-br 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
  }

  .payClosePopShou1 {
    background: rgba(0, 0, 0, 0);
    -webkit-animation: slide-bck-br1 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
    animation: slide-bck-br1 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
  }

  @keyframes slide-bck-br1 {
    0% {
      -webkit-transform: translateZ(0) translateY(0) translateX(0);
      transform: translateZ(0) translateY(0) translateX(0);
    }

    100% {
      -webkit-transform: translateZ(100px) translateY(200px) translateX(200px) scale(0);
      transform: translateZ(100px) translateY(200px) translateX(200px) scale(0);
    }
  }

  @keyframes slide-bck-br {
    0% {
      -webkit-transform: translateZ(0) translateY(0) translateX(0);
      transform: translateZ(0) translateY(0) translateX(0);
    }

    100% {
      -webkit-transform: translateZ(100px) translateY(200px) translateX(300px) scale(0);
      transform: translateZ(100px) translateY(200px) translateX(300px) scale(0);
    }
  }

  .Popuppanel {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.34);
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;

    .coupon_panel {
      width: 345px;
      animation: slide-fwd-center 0.45s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;

      .panel_header {
        height: 130px;
        background-image: url("./images/payImg/img_icon_40_1.png");
        background-size: 100% 100%;
        padding-top: 90px;
        text-align: center;

        .red_line {
          font-size: 16px;
          color: #ec3b3b;
          font-weight: bold;
          line-height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;

          .red_bao_box {
            .red_img_ic {
              width: 16px;
              height: 16px;
              margin-right: 5px;
              font-size: 0;
            }

            display: flex;
            align-items: center;
            color: #019fe8;
            margin: 0 5px;
          }
        }

        .gray_line {
          color: #999;
          font-size: 12px;
          line-height: 28px;
          margin-bottom: 15px;
        }
      }

      .panel_content {
        background-color: #fff;
        border-bottom-left-radius: 25px;
        border-bottom-right-radius: 25px;
        padding: 30px 40px 10px;

        .coupon_line {
          display: flex;
          align-items: center;
          height: 60px;
          margin-bottom: 6px;
          background-image: url("./images/payImg/img_icon_41.png");
          background-size: 100% 100%;

          .line_left {
            width: 90px;
            flex-shrink: 0;
            color: #ec3b3b;
            font-weight: bold;
            text-align: center;
            font-size: 30px;

            .coupon_unit {
              font-size: 14px;
            }
          }

          .line_right {
            flex-grow: 1;
            padding-left: 15px;
            text-align: left;

            .right_name {
              font-weight: 700;
              line-height: 23px;
              font-size: 13px;
              color: #000;
            }

            .right_desc {
              font-size: 12px;
              line-height: 22px;
              color: #999;
            }
          }
        }

        .receive_btn {
          display: block;
          width: 100%;
          height: 40px;
          margin: 0px auto;
          margin-top: 20px;
          color: #fff;
          background-color: #ec3b3b;
          border: none;
          border-radius: 26px;
          cursor: pointer;
        }

        .light_line {
          line-height: 40px;
          color: #ccc;
          font-size: 12px;
          cursor: pointer;
          text-align: center;
        }
      }
    }
  }
}

.paynewBoxDon {
  background: rgba(0, 0, 0, 0);
  -webkit-animation: slide-bck-br2 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;
  animation: slide-bck-br2 1s cubic-bezier(0.470, 0.000, 0.745, 0.715) both;

  @-webkit-keyframes slide-bck-br2 {
    0% {
      -webkit-transform: translateZ(0) translateY(0) translateX(0);
      transform: translateZ(0) translateY(0) translateX(0);
    }

    100% {
      -webkit-transform: translateZ(100px) translateY(-260px) translateX(-260px) scale(0);
      transform: translateZ(100px) translateY(-260px) translateX(-260px) scale(0);
    }
  }

  @keyframes slide-bck-br2 {
    0% {
      -webkit-transform: translateZ(0) translateY(0) translateX(0);
      transform: translateZ(0) translateY(0) translateX(0);
    }

    100% {
      -webkit-transform: translateZ(100px) translateY(-260px) translateX(-260px) scale(0);
      transform: translateZ(-200px) translateY(-500px) translateX(500px) scale(0);
    }
  }

}
</style>
